/**
 * Custom hook to get current user authentication state and user data
 * Now uses AuthContext for consistent state across all components
 */

import { useAuth as useAuthContext } from '../context/AuthContext';

// Re-export the context hook for backward compatibility
export const useAuth = useAuthContext;
